import Promise from 'bluebird';
import config from '../../config';

const preferredMethodOfContact = {
    'Do not contact me back': 'Do Not Contact',
    'Contact me back via phone': 'Phone',
    'Contact me back via email': 'Email'
};

/**
 * Map Form Data
 * @description data entry mapping to defined object model for encoded form assembly
 * @param formData
 * @param captchaSettings
 * @returns {object}
 */
const mapFormData = (formData) => {

    const captchaSettings =
        `{"keyname":${config.captchaKeyName}, "fallback":"true", "orgId":${config.orgId}, "ts":"${formData.reCaptchaTimeStamp}"}`;

    const mappedData = {
        orgid: config.orgId,
        retURL: 'https://www.wendys.com/',
        captcha_settings: captchaSettings,
        'g-recaptcha-response': formData.reCaptchaResponse,
        type: formData.feedBackType,
        description: formData.comments,
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.emailId,
        phone: formData.phone,
        external: '1'
    };
    mappedData[config.subCategory1] = formData.feedBackCategory;
    mappedData[config.dateOfVisit] = formData.date;
    mappedData[config.typeOfVisit] = formData.diningType;
    mappedData[config.preferredContactTime] = formData.preferredContactTime;
    mappedData[config.locationID] = formData.locationId;

    if (formData.time) {
        const amPm = formData.time.slice(-2);
        const time = formData.time.substring(0, formData.time.length - 2);

        mappedData[config.timeOfVisit] = time;
        mappedData[config.amPm] = amPm;
    }

    if (formData.contactPreference) {
        mappedData[config.preferredMethodOfContact] =
            preferredMethodOfContact[formData.contactPreference];
    }

    return mappedData;
};

/**
 * Encoded Form Data Assembly
 * @description assembly of form data for Sales Force
 * @param formData
 * @returns {string}
 */
const encodedFormDataAssembly = (formData) => {
    const urlEncodedDataPairs = [];

    // Turn the data object into an array of URL-encoded key/value pairs.
    Object.keys(formData).forEach((key) => {
        urlEncodedDataPairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(formData[key])}`);
    });

    /* Combine the pairs into a single string and replace all %-encoded spaces to
     * the '+' character; matches the behavior of browser form submissions.
     */
    const urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');

    return urlEncodedData;
};

/**
 * Customer Care form submission
 * @param formData
 */
const submitForm = (formData) => {
    return new Promise((resolve, reject) => {
        const encodedForm = encodedFormDataAssembly(mapFormData(formData));

        /*
        * Field mapping and assembly to encoded form key=value string
        * alternate form body format for testing
        */
        const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
        xhr.open('POST', config.servletUrl);
        xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
        xhr.onload = () => resolve();
        xhr.onerror = () => resolve();

        xhr.send(encodedForm);
    });
};

export default submitForm;



// WEBPACK FOOTER //
// ./src/services/serviceClient/index.js